<template>
  <div class="editor-section">
    <h3 class="blue-text">{{L10n('po')}}</h3>
    <form-editor
      ref="Form"
      v-loading="isLoading"
      :data="data"
      :model="formModel"
      @updateModelItem="handlerUpdateModelItem"
      @change="handleFormData"
    ></form-editor>
  </div>
</template>

<script>

import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import EditorSection from './EditorSection'
import { api } from '@/services/api'

export default {
  name: 'EditorRGQSection',
  mixins: [EditorSection, FormWrapperAutoSave],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Invoice' */ './FormRFQ')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'RFQs/Patch/${data.id}',
      // eslint-disable-next-line
      apiGet: 'RFQs/GetAllDynamic?select=id,rfqid,priorityID,customerCompanyID,customerContactID,customerCompanyDetailID,poDate,paymentTermID,customerForwarderID,shipToCompanyID,shipToContactID,shipToCompanyDetailID&filter=rfqid.contains("${data.mainID}")'
    }
  },
  computed: {
    isAvailableToSave () {
      return this.mainID
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        poDate: '',
        priorityID: null,
        paymentTermID: null,

        customerCompanyID: null,
        customerContactID: null,
        customerCompanyDetailID: null,

        customerForwarderID: null,
        shipToCompanyID: null,
        shipToContactID: null,
        shipToCompanyDetailID: null
      }
    },
    saveSection (callback) {
      let data = this.getFormData()
      api
        .patch(`RFQs/Patch/${data.id}`, data)
        .then(() => {
          callback()
        })
        .catch((err) => {
          callback(err)
        })
    },
    validateSection (callback) {
      if (!this.$refs.Form) {
        let message = `not found form for ${this.sectionID}`
        // eslint-disable-next-line
        console.error(message)
        return callback(new Error(message))
      }
      this.$refs.Form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error(`${this.sectionID} is invalid`))
        })
    }
  }
}
</script>
